import { render, staticRenderFns } from "./Login-Layout.vue?vue&type=template&id=6202fe0a&"
import script from "./Login-Layout.vue?vue&type=script&lang=js&"
export * from "./Login-Layout.vue?vue&type=script&lang=js&"
import style0 from "./Login-Layout.vue?vue&type=style&index=0&id=6202fe0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports